import type React from 'react'
import { connect } from 'react-redux'

import { isVisibleForAccountantOrAdmin } from '@helpers'
import { permissionDeniedForUser } from '@permissions/helpers'

import type { TmsUserFeaturePermissions } from '@constants'

interface FeatureDeniedForUserOwnProps {
  permission: TmsUserFeaturePermissions
}
interface FeatureDeniedForUserProps extends FeatureDeniedForUserOwnProps {
  children: React.ReactNode
  isFeatureDeniedForUser: boolean
}

function BaseFeatureDeniedForUser({ children, isFeatureDeniedForUser }: FeatureDeniedForUserProps) {
  if (isFeatureDeniedForUser) {
    return null
  }

  return <>{children}</>
}

export const FeatureDeniedForUser = connect((state: Store, { permission }: FeatureDeniedForUserOwnProps) => ({
  isFeatureDeniedForUser: permissionDeniedForUser(state, permission),
}))(BaseFeatureDeniedForUser)

FeatureDeniedForUser.displayName = 'FeatureDeniedForUser'

interface BaseAccountingButtonVisibilityControlProps {
  children: React.ReactNode
  company: Company
}

/**
 * A könyvelő role-nak mindig ott a könyvelés gomb - csomagtól függetlenül
 * Az admin alapból nem látja a könyvelés gombot, de ha akarja, bekapcsolhatja magának - csomagtól függetlenül
 */
function BaseAccountingButtonVisibilityControl({ children, company }: BaseAccountingButtonVisibilityControlProps) {
  if (isVisibleForAccountantOrAdmin(company)) {
    return <>{children}</>
  }

  return null
}

export const AccountingButtonVisibilityControl = connect((state: Store) => ({
  company: state.auth.company.data,
}))(BaseAccountingButtonVisibilityControl)

AccountingButtonVisibilityControl.displayName = 'AccountingButtonVisibilityControl'
